import React from 'react';

const RADIUS = 18;
const STROKE = 3;
const TEXT_COLOR = 'var(--color-fg-default)';
const START_COLOR = 'var(--color-success-default)';
const MID_COLOR = 'var(--color-warning-default)';
const END_COLOR = 'var(--color-danger-default)';
const BG_COLOR = 'var(--color-bg-muted)';

const getColor = (progress: number) => {
  if (progress > 0.6) return END_COLOR;
  if (progress > 0.3) return MID_COLOR;
  return START_COLOR;
};

interface TrialProgressCircleProps {
  remaining: number;
  total: number;
}

const TrialProgressCircle = ({
  remaining,
  total,
}: TrialProgressCircleProps) => {
  const progress = (total - remaining) / total;
  const innerRadius = RADIUS - STROKE;
  const diameter = innerRadius * 2 * Math.PI;
  const strokeDashoffset = (1 - progress) * diameter;

  const pathDescription = `
           M ${RADIUS} ${STROKE}
           a ${innerRadius} ${innerRadius} 0 0 1 0 ${innerRadius * 2}
           a ${innerRadius} ${innerRadius} 0 0 1 0 -${innerRadius * 2}`;
  return (
    <svg height={RADIUS * 2} width={RADIUS * 2}>
      <text
        fill={TEXT_COLOR}
        x={RADIUS}
        y={RADIUS}
        dominantBaseline="central"
        textAnchor="middle"
      >
        {remaining}
      </text>
      <path
        fill="none"
        stroke={BG_COLOR}
        strokeWidth={STROKE}
        d={pathDescription}
      />
      <path
        fill="none"
        stroke={getColor(progress)}
        strokeDasharray={`${diameter} ${diameter}`}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        strokeWidth={STROKE}
        d={pathDescription}
      />
    </svg>
  );
};

export default TrialProgressCircle;
